export default __webpack_public_path__ + "static/media/animalfarm.8dcd8fa5.png";